import { User } from './user';
export class Account {
	rights: string;
	systemCode: number;
	user: User;

	constructor() {

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/models/account.ts